import {connect} from 'react-redux';

import Notification from './Notification';

/**
 * Returns the two notifications with the highest priority.
 */
const getNotifications = notifications => (
    notifications.sort((left, right) => left.priority - right.priority).slice(0, 2)
);

const UserNotifications = ({notifications}) => getNotifications(notifications).map(notification => (
    <Notification {...notification} key={notification.id} />
));

const mapStateToProps = ({notifications}) => ({notifications});

export default connect(mapStateToProps)(UserNotifications);
